import React from 'react';
import PropTypes from 'prop-types';
import Spacer from '@deliveroo/consumer-component-library/components/Spacer';
import ResponsiveGridLayoutComponent from '../../../../components/ResponsiveGridLayout';
import { renderComponentTree } from '../../dynamicComponentTree';

// the following child components are supported:
import Heading from '../Heading';
import ImageWithCaption from '../ImageWithCaption';
import RestaurantCardHome from '../RestaurantCardHome';
import RichText from '../RichText';
import RichTextCard from '../RichTextCard';
import RichTextLongCard from '../RichTextLongCard';

const components = {
  Heading,
  ImageWithCaption,
  RestaurantCardHome,
  RichText,
  RichTextCard,
  RichTextLongCard,
};

const TWO_COLUMN = 'TWO_COLUMN';
const THREE_COLUMN = 'THREE_COLUMN';
const FOUR_COLUMN = 'FOUR_COLUMN';

// rather than allowing content creators complete control of the
// ResponsiveGridLayout props, we have exposed a `preset` option
// in Storyblok, which maps to sensible column/width combinations
class ResponsiveGridLayout extends React.Component {
  validateProps({ items, preset }) {
    return [TWO_COLUMN, THREE_COLUMN, FOUR_COLUMN].indexOf(preset) > -1 && Array.isArray(items);
  }

  componentDidMount() {
    const { items, preset } = this.props;

    if (!this.validateProps({ items, preset })) {
      throw new Error(`Incorrect prop-types for Storyblok ResponsiveGridLayout component`);
    }
  }

  render() {
    const { items, preset } = this.props;
    let maxColumns;
    let minColumnWidth;

    switch (preset) {
      case TWO_COLUMN:
        maxColumns = 2;
        minColumnWidth = 400;
        break;
      case THREE_COLUMN:
        maxColumns = 3;
        minColumnWidth = 260;
        break;
      case FOUR_COLUMN:
      default:
        maxColumns = 4;
        minColumnWidth = 160;
        break;
    }

    return (
      <Spacer spacing="medium 0">
        <ResponsiveGridLayoutComponent maxColumns={maxColumns} minColumnWidth={minColumnWidth}>
          {renderComponentTree(items, components)}
        </ResponsiveGridLayoutComponent>
      </Spacer>
    );
  }
}

ResponsiveGridLayout.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({ props: PropTypes.shape })).isRequired,
  preset: PropTypes.string,
};

ResponsiveGridLayout.defaultProps = {
  preset: FOUR_COLUMN,
};

export default ResponsiveGridLayout;
